import { useClient } from '@composables/use-clients';
import { PostRequestArgsType } from '@api/v1/types';
import { urls } from '@api/urls';
import { withTryCatch } from '@api/v1/error-handlers';

export type TokenRefreshSerializer = {
  refresh: string;
  access: string;
  access_expires_in: number;
};

export type PostTokenRefreshPayloadType = (
  Pick<TokenRefreshSerializer, 'refresh'>
);
export type PostTokenRefreshResponseType = (
  Pick<TokenRefreshSerializer, 'access' | 'access_expires_in'>
);

export const apiRefreshAccessToken = ({
  payload,
  errorConfig = {},
  callbacks = {},
}: PostRequestArgsType<PostTokenRefreshPayloadType>) => {
  const impl = async () => {
    const { client } = useClient('public');
    const res = await client.post({
      url: urls.v1.tokenRefresh(),
      payload,
    });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};
